import {
  CLEAR_AGING_BALANCE,
  CLEAR_AGING_BALANCE_OPTIONS,
  LOAD_AGING_BALANCE,
  LOAD_AGING_BALANCE_RESUME_LIST,
  SAVE_AGING_BALANCE_OPTIONS,
  SAVE_AGING_BALANCE_RESUME_OPTIONS,
  CLEAR_AGING_BALANCE_RESUME_OPTIONS,
  CLEAR_AGING_BALANCE_RESUME
} from '../actions/accountingActions';

const initialState = {
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0,
    balanceType: 'CLIENT',
    clientName: ''
  },
  items: [],
  count: 0,
  resumeOptions: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0,
    startDate: null,
    endDate: null
  },
  resumeItems: [],
  resumeCount: 0
};

const accountingReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_AGING_BALANCE.success: {
      return {
        ...state,
        items: action.items,
        count: action.count
      };
    }
    case LOAD_AGING_BALANCE_RESUME_LIST.success: {
      return {
        ...state,
        resumeItems: action.items,
        resumeCount: action.count
      };
    }
    case SAVE_AGING_BALANCE_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case SAVE_AGING_BALANCE_RESUME_OPTIONS: {
      return {
        ...state,
        resumeOptions: { ...state.resumeOptions, ...action.options }
      };
    }
    case CLEAR_AGING_BALANCE_OPTIONS: {
      return {
        ...state,
        options: initialState.options
      };
    }
    case CLEAR_AGING_BALANCE_RESUME_OPTIONS: {
      return {
        ...state,
        resumeOptions: initialState.resumeOptions
      };
    }
    case CLEAR_AGING_BALANCE: {
      return initialState;
    }
    case CLEAR_AGING_BALANCE_RESUME: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default accountingReducer;
